<template>
  <!-- Tema do Connect: sol (claro) a esquerda, lua (escuro) a direita. -->
  <pref-switch
    :on="isDark"
    :mini="mini"
    rotate
    :label="ariaLabel"
    :tooltip="$t('sidebar.switchThemeTo', { theme: nextLabel })"
    @toggle="toggle"
  >
    <template v-slot:off="{ place }">
      <svg class="theme-sun" :class="`theme-sun--${place}`" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="4.2" />
        <path
          d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M5.3 5.3 7 7M17 17l1.7 1.7M5.3 18.7 7 17M17 7l1.7-1.7"
        />
      </svg>
    </template>
    <template v-slot:on="{ place }">
      <svg
        class="theme-moon"
        :class="`theme-moon--${place}`"
        viewBox="0 0 24 24"
      >
        <path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />
      </svg>
    </template>
  </pref-switch>
</template>

<script>
import PrefSwitch from "@/components/PrefSwitch.vue";
import { setTheme } from "@/plugins/theme";
import pitchCustomerApi from "@/shared/pitchCustomerApi";
import pitchPartnerApi from "@/shared/pitchPartnerApi";

export default {
  name: "ThemeSwitcher",

  components: { PrefSwitch },

  props: {
    mini: { type: Boolean, default: false },
  },

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    currentLabel() {
      return this.isDark
        ? this.$t("sidebar.themeDark")
        : this.$t("sidebar.themeLight");
    },
    nextLabel() {
      return this.isDark
        ? this.$t("sidebar.themeLight")
        : this.$t("sidebar.themeDark");
    },
    ariaLabel() {
      return `${this.$t("sidebar.theme")}: ${this.currentLabel}. ${this.$t(
        "sidebar.switchThemeTo",
        { theme: this.nextLabel }
      )}`;
    },
  },

  methods: {
    // A tela troca na hora; a escolha vai para o usuario em seguida, para
    // valer nos proximos logins em qualquer aparelho (como o idioma).
    async toggle() {
      const theme = this.isDark ? "light" : "dark";
      setTheme(theme, this.$vuetify);

      const api =
        this.$store.getters.module === "professor"
          ? pitchPartnerApi
          : pitchCustomerApi;

      try {
        await api.updateTheme(theme);
        this.$store.commit("SET_USER", {
          ...(this.$store.getters.user || {}),
          theme,
        });
      } catch {
        this.$root.$emit("display-alert", {
          text: this.$t("sidebar.themeSaveFailed"),
          type: 1,
        });
      }
    },
  },
};
</script>

<style scoped>
.theme-sun circle,
.theme-moon path {
  fill: currentColor;
}

.theme-sun path {
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
}

/* No botao, em cor: sol rosa, lua uva. No trilho herdam o tom apagado. */
.theme-sun--thumb {
  color: var(--pc-pink);
}

.theme-moon--thumb {
  color: var(--pc-grape);
}
</style>
